import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const HireUs = () => {
    return (
        <Container>
            <h1>Want to <span>Hire Us?</span></h1>
            <div className="services__button">
                <Link to="/contactus">Let's Connect</Link>
            </div>
        </Container>
    )
}

export default HireUs


const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background: black;
    height: 10rem;
    /* margin-top: -5rem;    */
    h1{
        color: #fff;
        font-size: 4rem;
        margin-right: 2rem;
        span{
            color: #fff;
        }
    }
    a {    
        text-align: center;
        text-decoration: none;
        padding: 0.8rem 1rem;
        font-size: 1.3rem;
        color: #fff;
        transition: 0.3s ease;
        margin: 1rem 1rem 0rem 1rem;
        /* border: 2px solid #23d997; */
        border: none;
        box-shadow: 0 0.25rem 0.5rem rgba(255, 255, 255, 0.4) inset;
        background: #E21F36;
        &:hover {
        /* opacity: 0.8; */
        background: orangered;
        }
    }
    @media screen and (max-width: 900px) {
        /* flex-direction: column; */
        /* margin-top: -5rem; */
        height: 5rem;
        h1{
            font-size: 1.5rem;
            margin-right: 0.5rem;
        }
        a{
            padding: 0.3rem;
            font-size: 1rem;
        }
    }
`

const Content = styled.div`
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.5rem 15rem;
    border-radius: 1rem;
    
`